import { Funcionalidades } from '@/config/funcionalidades';
import Cotizador from '@/pantallas/SucursalVirtual/Cotizador/index.vue';

const CotizadorRoutes = [
  {
    path: '/Sucursal-Virtual/cotizador',
    component: Cotizador,
    meta: {
      description: 'Torre de Control',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.Cotizador,
    },
  },
];

export default CotizadorRoutes;
